import { useState, useEffect } from "react";
import adminApi from "../api/adminAxios";

export default function GeneralSettings() {
  const [shippingCharge,     setShippingCharge]     = useState("");
  const [freeShippingAbove,  setFreeShippingAbove]  = useState("");
  const [loading, setLoading]   = useState(true);
  const [saving,  setSaving]    = useState(false);
  const [saved,   setSaved]     = useState(false);
  const [error,   setError]     = useState("");

  useEffect(() => {
    adminApi.get("admin/settings/")
      .then(r => {
        setShippingCharge(r.data.shipping_charge);
        setFreeShippingAbove(r.data.free_shipping_above);
      })
      .catch(() => setError("Failed to load settings."))
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setError(""); setSaved(false);
    const charge = parseFloat(shippingCharge);
    const free   = parseFloat(freeShippingAbove);
    if (isNaN(charge) || charge < 0) { setError("Enter a valid shipping charge (₹0 or more)."); return; }
    if (isNaN(free)   || free   < 0) { setError("Enter a valid free-shipping threshold (₹0 or more)."); return; }

    setSaving(true);
    try {
      await adminApi.patch("admin/settings/", {
        shipping_charge:     charge,
        free_shipping_above: free,
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch {
      setError("Failed to save. Please try again.");
    }
    setSaving(false);
  };

  return (
    <div style={{ padding: "32px 36px", fontFamily: "Georgia, serif" }}>

      {/* Header */}
      <div style={{ marginBottom: "32px" }}>
        <h1 style={{ fontFamily: "Georgia, serif", fontSize: "24px", fontWeight: "700", color: "#1a1a1a" }}>
          General Settings
        </h1>
        <p style={{ fontFamily: "Georgia, serif", fontSize: "13px", color: "#aaa", marginTop: "4px" }}>
          Manage site-wide configuration. Changes apply immediately to the checkout page.
        </p>
      </div>

      {loading ? (
        <p style={{ fontFamily: "Georgia, serif", fontSize: "13px", color: "#aaa" }}>Loading settings...</p>
      ) : (
        <div style={{ maxWidth: "540px" }}>

          {/* Shipping Card */}
          <div style={{ background: "#fff", borderRadius: "16px", padding: "28px", border: "1px solid #f0ebe3", marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "22px" }}>
              <span style={{ fontSize: "22px" }}>🚚</span>
              <div>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "15px", fontWeight: "700", color: "#1a1a1a" }}>Shipping Charges</p>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#aaa" }}>Applied at checkout for all orders</p>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "18px" }}>

              {/* Shipping charge */}
              <div>
                <label style={{ display: "block", fontFamily: "Georgia, serif", fontSize: "11px", fontWeight: "700", color: "#5a3a1a", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "8px" }}>
                  Flat Shipping Charge (₹)
                </label>
                <div style={{ position: "relative" }}>
                  <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", fontFamily: "Georgia, serif", fontSize: "14px", color: "#aaa", fontWeight: "700" }}>₹</span>
                  <input
                    type="number" min="0" value={shippingCharge}
                    onChange={e => setShippingCharge(e.target.value)}
                    style={{ width: "100%", padding: "11px 12px 11px 28px", borderRadius: "10px", border: "1.5px solid #e8d5b8", background: "#fffaf4", fontFamily: "Georgia, serif", fontSize: "15px", fontWeight: "700", color: "#1a1a1a", outline: "none", boxSizing: "border-box" }}
                  />
                </div>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "10px", color: "#bbb", marginTop: "5px" }}>
                  Charged on every order below the free threshold.
                </p>
              </div>

              {/* Free shipping above */}
              <div>
                <label style={{ display: "block", fontFamily: "Georgia, serif", fontSize: "11px", fontWeight: "700", color: "#5a3a1a", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "8px" }}>
                  Free Shipping Above (₹)
                </label>
                <div style={{ position: "relative" }}>
                  <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", fontFamily: "Georgia, serif", fontSize: "14px", color: "#aaa", fontWeight: "700" }}>₹</span>
                  <input
                    type="number" min="0" value={freeShippingAbove}
                    onChange={e => setFreeShippingAbove(e.target.value)}
                    style={{ width: "100%", padding: "11px 12px 11px 28px", borderRadius: "10px", border: "1.5px solid #e8d5b8", background: "#fffaf4", fontFamily: "Georgia, serif", fontSize: "15px", fontWeight: "700", color: "#1a1a1a", outline: "none", boxSizing: "border-box" }}
                  />
                </div>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "10px", color: "#bbb", marginTop: "5px" }}>
                  Set to 0 to always charge shipping.
                </p>
              </div>
            </div>

            {/* Live preview */}
            <div style={{ marginTop: "20px", padding: "14px 18px", background: "#faf7f2", borderRadius: "12px", border: "1px solid #f0ebe3" }}>
              <p style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#aaa", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "8px" }}>Live Preview</p>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                <span style={{ fontFamily: "Georgia, serif", fontSize: "12px", color: "#555" }}>Order below ₹{parseFloat(freeShippingAbove) || 999}</span>
                <span style={{ fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "700", color: "#c47a3a" }}>+₹{parseFloat(shippingCharge) || 0} shipping</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ fontFamily: "Georgia, serif", fontSize: "12px", color: "#555" }}>Order ₹{parseFloat(freeShippingAbove) || 999} or above</span>
                <span style={{ fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "700", color: "#3a8a68" }}>Free Shipping 🎉</span>
              </div>
            </div>
          </div>

          {/* Error / success */}
          {error && (
            <div style={{ background: "#fff0f0", border: "1px solid #f5c6c6", borderRadius: "10px", padding: "12px 16px", marginBottom: "16px", fontFamily: "Georgia, serif", fontSize: "12px", color: "#c0392b" }}>
              ⚠ {error}
            </div>
          )}
          {saved && (
            <div style={{ background: "#eefaf4", border: "1px solid #a8dfc4", borderRadius: "10px", padding: "12px 16px", marginBottom: "16px", fontFamily: "Georgia, serif", fontSize: "12px", color: "#3a8a68", fontWeight: "700" }}>
              ✅ Settings saved! Checkout will now use the updated shipping charge.
            </div>
          )}

          <button onClick={handleSave} disabled={saving}
            style={{ padding: "13px 36px", borderRadius: "10px", background: saving ? "#ccc" : "linear-gradient(135deg,#e07b39,#c96a18)", color: "#fff", border: "none", cursor: saving ? "not-allowed" : "pointer", fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: "700", letterSpacing: "0.04em" }}>
            {saving ? "Saving..." : "💾 Save Settings"}
          </button>
        </div>
      )}
    </div>
  );
}